import Seo from "@/components/Seo";
import ProductCard from "@/components/ProductCard";
import ComparisonTable from "@/components/ComparisonTable";
import IngredientsSection from "@/sections/IngredientsSection";
import InstallationSection from "@/sections/InstallationSection";
import { PRODUCTS, DELIVERY } from "@/data/content";
import { Truck, PackageCheck, MapPin } from "lucide-react";

export default function ShopPage() {
  return (
    <main data-testid="shop-page" className="pt-28 md:pt-36">
      <Seo
        title="Kauppa – JINSU-suihkusuodattimet"
        description="Tutustu JINSU-suihkusuodattimiin: Jinsu Suodatin 19,90 € sekä Vitamiinisuodatin Jasmin ja Mandariini 24,90 €. Toimitus Postilla kaikkialle Suomeen."
      />

      <section className="mx-auto max-w-7xl px-5 sm:px-8">
        <p className="eyebrow text-water-deep/80">Verkkokauppa</p>
        <h1 className="h-display font-heading mt-5 font-semibold text-foreground" lang="fi">
          Suihkusuodattimet
        </h1>
        <p className="mt-6 max-w-2xl text-base md:text-lg leading-relaxed text-muted-foreground">
          Puhtaampaa vettä ihollesi ja hiuksillesi – joka suihkussa. Kaikki hinnat sisältävät ALV:n,
          toimituskulut lisätään kassalla.
        </p>

        <div className="mt-12 md:mt-16 grid gap-7 md:grid-cols-2 lg:grid-cols-3">
          {PRODUCTS.map((p) => (
            <ProductCard key={p.slug} product={p} />
          ))}
        </div>
      </section>

      <IngredientsSection />
      <InstallationSection />

      <section className="mx-auto max-w-7xl px-5 sm:px-8 py-24 md:py-32">
        <div className="max-w-3xl">
          <p className="eyebrow text-water-deep/80">Vertailu</p>
          <h2 className="h-section font-heading mt-5 font-semibold text-foreground" lang="fi">
            Mikä suodatin sopii sinulle?
          </h2>
        </div>
        <div className="mt-12">
          <ComparisonTable />
        </div>
      </section>

      <section className="bg-water-soft/50 py-20 md:py-28">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <h2 className="h-section font-heading font-semibold text-foreground" lang="fi">
            Toimitus
          </h2>
          <div className="mt-10 grid gap-6 md:grid-cols-3">
            <div className="flex items-start gap-4 rounded-3xl bg-white p-7 shadow-sm">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-water text-water-deep">
                <PackageCheck size={20} strokeWidth={1.8} />
              </span>
              <div>
                <h3 className="font-bold text-foreground text-sm">Käsittely</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-muted-foreground">{DELIVERY.processing}</p>
              </div>
            </div>
            <div className="flex items-start gap-4 rounded-3xl bg-white p-7 shadow-sm">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-water text-water-deep">
                <Truck size={20} strokeWidth={1.8} />
              </span>
              <div>
                <h3 className="font-bold text-foreground text-sm">Toimitusaika</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-muted-foreground">{DELIVERY.time}</p>
              </div>
            </div>
            <div className="flex items-start gap-4 rounded-3xl bg-white p-7 shadow-sm">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-water text-water-deep">
                <MapPin size={20} strokeWidth={1.8} />
              </span>
              <div>
                <h3 className="font-bold text-foreground text-sm">Toimitustapa</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-muted-foreground">{DELIVERY.method}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
